import { EntityId, createAsyncThunk } from '@reduxjs/toolkit';
import {
  FavoritesReducerStateShape,
  clientFavoritesSlice,
  currentClientFavoriteApi,
  isClientFavoriteSelector,
} from '@cp/entities/client/current/favorite';

export const toggleFavoriteThunk = createAsyncThunk<void, EntityId, { state: FavoritesReducerStateShape }>(
  'user/toggleFavorite',
  async (clientId: EntityId, { dispatch, getState }) => {
    const state = getState();
    const isFavorite = isClientFavoriteSelector(state, clientId);
    const initiate = isFavorite
      ? currentClientFavoriteApi.endpoints.deleteFavoriteClient.initiate
      : currentClientFavoriteApi.endpoints.createFavoriteClient.initiate;
    // optimistic update
    dispatch(clientFavoritesSlice.actions.toggleFavorite(clientId));
    try {
      await dispatch(initiate({ clientId: clientId as number })).unwrap();
    } catch (err) {
      // rollback optimistic update
      dispatch(clientFavoritesSlice.actions.toggleFavorite(clientId));
      throw err;
    }
  },
);
